export const OUTBRAINE_MIN_VIEW_TIME = 1000;
export const OUTBRAINE_MIN_VIEW_PART = 0.5;

export const DEFAULT_OUTBRAIN_PERMALINK = 'http://www.mobileposse.com/VRZ/MOMENT/EN'

export type OutbrainWidgetId = 'JS_9' | 'JS_13';

export const DEFAULT_OUTBRAIN_WIDGET_ID: OutbrainWidgetId = 'JS_9';

export function resolveOutbrainWidgetId(value: unknown): OutbrainWidgetId {
  return value === 'JS_13' ? 'JS_13' : 'JS_9';
}

export function getOutbrainDocLimit(widgetId: OutbrainWidgetId): number {
  return widgetId === 'JS_13' ? 1 : 4;
}

export const OUTBRAIN_CONFIG = {
  widgetId: DEFAULT_OUTBRAIN_WIDGET_ID,
  installationKey: 'MOBIL10GC607HEAPB660KCI89',
};
